var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"copy-right"},[_vm._v(" Copyright©2025 汲悟科技版权所有 | "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v(_vm._s(_vm.beian))]),_vm._v(" | "),_c('a',{attrs:{"href":"https://news.gwotech.com/","target":"_blank"}},[_vm._v("吉物跨境")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }